import { TerminalItemDto } from "./TerminalInfoDto";

export interface IUserDto {
    contractCode: string | null;
    description: string | null;
    email: string | null;
    name: string | null;
    surname: string | null;
    userType: string | null;
    username: string;
    terminalInfo: TerminalItemDto[] | null;
}

export class UserDto implements IUserDto {
    public contractCode: string | null;
    public description: string | null;
    public email: string | null;
    public name: string | null;
    public surname: string | null;
    public userType: string | null;
    public username: string;
    public terminalInfo: TerminalItemDto[] | null;

    constructor(contractCode: string | null, description: string | null, email: string | null, name: string | null, surname: string | null, userType: string | null,
        username: string, terminalInfo: TerminalItemDto[] | null) {
        this.contractCode = contractCode;
        this.description = description;
        this.email = email;
        this.name = name;
        this.surname = surname;
        this.userType = userType;
        this.username = username;
        this.terminalInfo = terminalInfo;
    }
}